import {useEffect,useState} from 'react';
import type {ModelBrand} from '@reados/contracts';
import {api} from '../api';
import {usageModelOptions} from '../ai-usage';

/** Pricing is platform metadata and does not start a user sandbox. */
export function useUsageModels(userId:string,enabled=true,revision=0){
 const [models,setModels]=useState<{models:string[];displayNames:Record<string,string>;brands:Record<string,ModelBrand>}>({models:[],displayNames:{},brands:{}});
 useEffect(()=>{
  setModels({models:[],displayNames:{},brands:{}});if(!enabled)return;
  const controller=new AbortController();let active=true;
  void api.usagePricing(controller.signal).then(value=>{if(active)setModels({models:usageModelOptions(value.models.map(model=>model.model),value.modelIds??[]),displayNames:value.modelDisplayNames??{},brands:value.modelBrands??{}});}).catch(()=>{});
  return()=>{active=false;controller.abort();};
 },[userId,enabled,revision]);
 return models;
}
